import React from "react";
import { TabPanel } from "devextreme-react/tab-panel";
import "./../../../styles/tabStyle.css";

const PromineoTab = props => (
  <TabPanel animationEnabled={true}>{props.children}</TabPanel>
);

export default PromineoTab;
